function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty, noop } from 'lodash';
import gettext from 'js-utils/gettext';
import onClickOutsideHOC from '../utils/onClickOutsideDecorator';
import { Theme, THEME_PROP_TYPE } from '../theming';
import IconButton from '../iconButton/IconButton';
import Divider from '../divider/Divider';
import NavList from '../navList/NavList';
import Modal from '../modal/Modal';
import LoadingOverlay from '../loadingOverlay/LoadingOverlay';
import NotificationBar from '../notification/NotificationBar';
import Dialog from '../dialog/Dialog';
import FixedBottomBarLayout from '../containers/fixedBottomBarLayout/FixedBottomBarLayout';
import { ITEMS_PROP_TYPE } from '../navList/constants';
import { NOTIFICATION_OPTIONS_PROP_TYPES } from '../notification/constants';
import { OVERLAY_OPTIONS_PROP_TYPES, FOCUS_DRAWER_OPTIONS_PROP_TYPES, BOTTOM_BAR_OPTIONS_PROP_TYPE, STRUCTURE_MAIN_CONTAINER_CLASSNAME, NOTIFICATION_POSITION_TOAST, NOTIFICATION_POSITION_TOP } from './constants';
import CrossChunkySvg from '../iconography/icons/CrossChunky';
import MenuChunkySvg from '../iconography/icons/MenuChunky';
var OVERLAY_TYPE_MAP = {
  dialog: Dialog,
  modal: Modal
};

var MenuToggle = function MenuToggle(_ref) {
  var onToggle = _ref.onToggle,
      iconType = _ref.iconType,
      title = _ref.title;
  return React.createElement(IconButton, {
    iconType: iconType,
    title: title,
    onClick: onToggle
  });
};

var DrawerToggle = function DrawerToggle(_ref2) {
  var onToggle = _ref2.onToggle;

  if (!onToggle) {
    return null;
  }

  return React.createElement("div", {
    className: "eds-text--center",
    "data-spec": "eds-structure-drawer-toggle"
  }, React.createElement(MenuToggle, {
    onToggle: onToggle,
    iconType: React.createElement(CrossChunkySvg, null),
    title: gettext('Close')
  }));
};

var DrawerTitle = function DrawerTitle(_ref3) {
  var children = _ref3.children;

  if (!children) {
    return null;
  }

  return React.createElement("h3", {
    className: "eds-structure__drawer__title",
    "data-spec": "eds-structure-drawer-title"
  }, children);
};

var PageTitle = function PageTitle(_ref4) {
  var pageTitle = _ref4.pageTitle;
  return React.createElement("div", {
    className: "eds-g-cell eds-l-mar-vert-2 eds-l-mar-left-1 eds-structure__title__heading"
  }, React.createElement("h2", {
    className: "eds-structure__title__heading__text",
    "data-spec": "eds-structure-title-heading"
  }, pageTitle));
};

var PageHeader = function PageHeader(_ref5) {
  var component = _ref5.component,
      onToggleSideDrawer = _ref5.onToggleSideDrawer,
      showMenuToggle = _ref5.showMenuToggle;
  var menuToggle;
  var pageTitle;

  if (component) {
    pageTitle = React.createElement(PageTitle, {
      pageTitle: component
    });
  }

  if (showMenuToggle) {
    menuToggle = React.createElement("div", {
      className: "eds-l-mar-vert-2 eds-l-mar-left-2 eds-structure__title__toggle",
      "data-spec": "eds-structure-sidebar-toggle"
    }, React.createElement(MenuToggle, {
      onToggle: onToggleSideDrawer,
      iconType: React.createElement(MenuChunkySvg, null),
      title: gettext('Toggle Navigation')
    }));
  }

  if (menuToggle || pageTitle) {
    return React.createElement("div", {
      className: "eds-structure__title-container eds-g-group"
    }, React.createElement("div", {
      className: "eds-structure__title",
      "data-spec": "eds-structure-title"
    }, menuToggle, pageTitle));
  }

  return null;
};

var Notification = function Notification(_ref6) {
  var options = _ref6.options,
      fullWidth = _ref6.fullWidth;
  var component = null;

  if (!isEmpty(options)) {
    /* Should stick comes from the AddMainControls HOC to determine
    if the notification component should stick to top of viewport */

    /* isClosing comes from the AddMainControls HOC and the addFocusDrawerControls HOC
    to determine if the notification component should animate out of view */
    var position = options.position,
        shouldStick = options.shouldStick,
        isClosing = options.isClosing,
        notificationOptions = _objectWithoutProperties(options, ["position", "shouldStick", "isClosing"]);

    var isTop = !position || position === NOTIFICATION_POSITION_TOP;
    var isToast = position === NOTIFICATION_POSITION_TOAST;
    var classes = classNames('eds-structure__notification', {
      'eds-structure__notification--position-top': isTop,
      'eds-structure__notification--position-toast': isToast,
      'eds-structure__notification--sticky': shouldStick,
      'eds-structure__notification--is-closing': isClosing,
      'eds-g-cell-md-10-12': isTop && !fullWidth,
      'eds-g-offset-md-1-12': isTop && !fullWidth,
      'eds-g-cell-12-12': isTop && fullWidth
    });
    component = React.createElement("div", {
      className: classes
    }, React.createElement(NotificationBar, notificationOptions));
  }

  return component;
};

var DrawerHeader = function DrawerHeader(_ref7) {
  var children = _ref7.children,
      onToggle = _ref7.onToggle,
      hideToggle = _ref7.hideToggle;
  var drawerToggle;

  if (children || onToggle) {
    var titleClasses = classNames('eds-g-cell', 'eds-l-pad-top-4', 'eds-l-pad-bot-3', 'eds-l-pad-left-6', 'eds-l-pad-right-2', {
      'eds-g-cell-10-12': !hideToggle,
      'eds-g-cell-12-12': hideToggle
    });

    if (!hideToggle) {
      drawerToggle = React.createElement("div", {
        className: "eds-g-cell eds-g-cell-2-12 eds-l-pad-top-2"
      }, React.createElement(DrawerToggle, {
        onToggle: onToggle
      }));
    }

    return React.createElement("div", {
      className: "eds-structure__drawer-header",
      "data-spec": "eds-structure-drawer-header"
    }, React.createElement("div", {
      className: titleClasses
    }, React.createElement(DrawerTitle, null, children)), drawerToggle, React.createElement(Divider, null));
  }

  return null;
};

var Drawer = onClickOutsideHOC(function (_ref8) {
  var component = _ref8.component,
      title = _ref8.title,
      onToggle = _ref8.onToggle,
      hideToggle = _ref8.hideToggle,
      extraClassName = _ref8.extraClassName,
      notificationOptions = _ref8.notificationOptions,
      dataSpec = _ref8.dataSpec,
      alwaysInclude = _ref8.alwaysInclude;
  var drawer = null; // NOTE: For the purposes of initial animation, we may want to always include
  // the drawer container. That way if the drawer content is later added &
  // the drawer is shown, it won't just pop in

  if (component || alwaysInclude) {
    var className = classNames('eds-structure__drawer', extraClassName);
    drawer = React.createElement("aside", {
      className: className,
      "data-spec": dataSpec
    }, React.createElement(Notification, {
      options: notificationOptions,
      fullWidth: true
    }), React.createElement(DrawerHeader, {
      onToggle: onToggle,
      hideToggle: hideToggle
    }, title), React.createElement("div", {
      className: "eds-structure__drawer-content"
    }, component));
  }

  return drawer;
});

var SideDrawerDescription = function SideDrawerDescription(_ref9) {
  var component = _ref9.component;

  if (!component) {
    return null;
  }

  return React.createElement("section", {
    className: "eds-structure__left-drawer-description"
  }, component);
};

var SideDrawer = function SideDrawer(_ref10) {
  var items = _ref10.items,
      sideDrawerDescription = _ref10.sideDrawerDescription;
  return React.createElement("div", {
    className: "eds-structure__side-drawer",
    "data-spec": "eds-structure-side-drawer"
  }, React.createElement(SideDrawerDescription, {
    component: sideDrawerDescription
  }), React.createElement(NavList, {
    items: items,
    useAltTheme: true,
    showSymbols: true
  }));
};

var Body = function Body(_ref11) {
  var children = _ref11.children,
      navItems = _ref11.navItems,
      onSideDrawerDismiss = _ref11.onSideDrawerDismiss,
      onToggleSideDrawer = _ref11.onToggleSideDrawer,
      pageTitle = _ref11.pageTitle,
      hasIndependentScrolling = _ref11.hasIndependentScrolling,
      sideDrawerDescription = _ref11.sideDrawerDescription,
      notificationOptions = _ref11.notificationOptions,
      footer = _ref11.footer,
      _ref11$focusDrawerOpt = _ref11.focusDrawerOptions;
  _ref11$focusDrawerOpt = _ref11$focusDrawerOpt === void 0 ? {} : _ref11$focusDrawerOpt;
  var focusDrawerContent = _ref11$focusDrawerOpt.content,
      focusDrawerTitle = _ref11$focusDrawerOpt.title,
      hideFocusDrawerClose = _ref11$focusDrawerOpt.hideClose,
      onFocusDrawerClose = _ref11$focusDrawerOpt.onClose,
      _ref11$focusDrawerOpt2 = _ref11$focusDrawerOpt.bottomBarOptions,
      focusDrawerBottomBarOptions = _ref11$focusDrawerOpt2 === void 0 ? {} : _ref11$focusDrawerOpt2,
      focusDrawerNotificationOptions = _ref11$focusDrawerOpt.notificationOptions,
      onFocusDrawerClickOutside = _ref11$focusDrawerOpt.onClickOutside,
      focusDrawerIsShown = _ref11$focusDrawerOpt.isShown,
      _ref11$mainBottomBarO = _ref11.mainBottomBarOptions,
      mainBottomBarOptions = _ref11$mainBottomBarO === void 0 ? {} : _ref11$mainBottomBarO;
  var sideDrawer;
  var focusDrawer;
  var showMenuToggle = false; // If there are items then show the side drawer

  if (!isEmpty(navItems)) {
    sideDrawer = React.createElement(SideDrawer, {
      items: navItems,
      sideDrawerDescription: sideDrawerDescription
    });
    showMenuToggle = true;
  }

  if (focusDrawerContent) {
    focusDrawer = React.createElement("div", {
      className: "eds-structure__focus-drawer-content-wrapper eds-structure__drawer--fade-in"
    }, React.createElement(FixedBottomBarLayout, focusDrawerBottomBarOptions, focusDrawerContent));

    if (mainBottomBarOptions) {
      // eslint-disable-next-line no-param-reassign
      mainBottomBarOptions = _objectSpread({}, mainBottomBarOptions, {
        isShown: false
      });
    }
  }

  var mainContent = React.createElement("div", {
    className: STRUCTURE_MAIN_CONTAINER_CLASSNAME
  }, React.createElement(PageHeader, {
    component: pageTitle,
    onToggleSideDrawer: onToggleSideDrawer,
    showMenuToggle: showMenuToggle
  }), React.createElement("main", {
    className: "eds-structure__main",
    "data-spec": "eds-structure-main"
  }, children), footer);

  if (hasIndependentScrolling) {
    mainContent = React.createElement("div", {
      className: "eds-structure__fixed-bottom-bar-layout-wrapper"
    }, React.createElement(FixedBottomBarLayout, mainBottomBarOptions, mainContent));
  }

  return React.createElement("div", {
    className: "eds-structure__body"
  }, React.createElement(Drawer, {
    component: sideDrawer,
    extraClassName: "eds-structure__left-drawer",
    dataSpec: "eds-structure-drawer-left",
    onClickOutside: onSideDrawerDismiss
  }), React.createElement(Drawer, {
    component: focusDrawer,
    title: focusDrawerTitle,
    hideToggle: hideFocusDrawerClose,
    onToggle: onFocusDrawerClose,
    notificationOptions: focusDrawerNotificationOptions,
    dataSpec: "eds-structure-drawer-right",
    extraClassName: "eds-structure__right-drawer",
    alwaysInclude: true,
    onClickOutside: focusDrawerIsShown ? onFocusDrawerClickOutside : noop
  }), React.createElement("div", {
    className: "eds-structure__main-mask",
    "data-spec": "eds-structure-main-mask"
  }, React.createElement(Notification, {
    options: notificationOptions
  }), mainContent));
};

var Overlay = function Overlay(_ref12) {
  var options = _ref12.options;
  var component = null;

  if (options) {
    var kind = options.kind,
        overlayOptions = _objectWithoutProperties(options, ["kind"]);

    var OverlayType = OVERLAY_TYPE_MAP[kind];
    component = React.createElement(OverlayType, overlayOptions);
  }

  return component;
};

var FixedLoadingOverlay = function FixedLoadingOverlay(_ref13) {
  var isLoading = _ref13.isLoading;
  var component = null;

  if (isLoading) {
    component = React.createElement("div", {
      className: "eds-structure__loading-overlay"
    }, React.createElement(LoadingOverlay, {
      isShown: isLoading
    }));
  }

  return component;
};

var Structure =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Structure, _React$PureComponent);

  function Structure(props) {
    var _this;

    _classCallCheck(this, Structure);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Structure).call(this, props));
    var showSideDrawer = props.showSideDrawer;
    _this.state = {
      showSideDrawer: showSideDrawer
    };
    return _this;
  }

  _createClass(Structure, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref14) {
      var showSideDrawer = _ref14.showSideDrawer;
      this.setState({
        showSideDrawer: showSideDrawer
      });
    }
  }, {
    key: "_handleToggleSideDrawer",
    value: function _handleToggleSideDrawer() {
      var _this2 = this;

      // NOTE: Due to the nature of the interactions between the showSideDrawer
      // prop, the showSideDrawer internal state, and how we default based
      // open screen size, we need to ensure that the toggled state has been set
      // before calling the handler by passing a callback to setState
      this.setState(function (_ref15) {
        var prevShowSideDrawer = _ref15.showSideDrawer;
        return {
          showSideDrawer: !prevShowSideDrawer
        };
      }, function () {
        if (_this2.props.onSideDrawerChange) {
          _this2.props.onSideDrawerChange(_this2.state.showSideDrawer);
        }
      });
    }
  }, {
    key: "_handleSideDrawerDismiss",
    value: function _handleSideDrawerDismiss() {
      // If the side drawer is not open
      if (!this.state.showSideDrawer) {
        return;
      }

      var showSideDrawer = false;
      this.setState({
        showSideDrawer: showSideDrawer
      });

      if (this.props.onSideDrawerChange) {
        this.props.onSideDrawerChange(showSideDrawer);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          header = _this$props.header,
          children = _this$props.children,
          overlayOptions = _this$props.overlayOptions,
          notificationOptions = _this$props.notificationOptions,
          footer = _this$props.footer,
          pageTitle = _this$props.pageTitle,
          navItems = _this$props.navItems,
          fullScreenMain = _this$props.fullScreenMain,
          noMinHeightMain = _this$props.noMinHeightMain,
          hasIndependentScrolling = _this$props.hasIndependentScrolling,
          sideDrawerDescription = _this$props.sideDrawerDescription,
          focusDrawerOptions = _this$props.focusDrawerOptions,
          mainBottomBarOptions = _this$props.mainBottomBarOptions,
          isLoading = _this$props.isLoading,
          rootTheme = _this$props.rootTheme;
      var showSideDrawer = this.state.showSideDrawer;
      var className = classNames('eds-structure', {
        'eds-structure--left-open': showSideDrawer,
        'eds-structure--right-open': focusDrawerOptions && focusDrawerOptions.isShown,
        'eds-structure--main-bottom-bar-open': mainBottomBarOptions && mainBottomBarOptions.isShown,
        'eds-structure--min-height': !noMinHeightMain,
        'eds-structure--independent-scrolling': hasIndependentScrolling,
        'eds-structure--restricted-width': !fullScreenMain
      });
      return React.createElement(Theme, {
        theme: rootTheme,
        isRoot: true
      }, function (themeProps) {
        return React.createElement("div", _extends({}, themeProps, {
          className: className,
          role: "region",
          "data-spec": "eds-structure"
        }), React.createElement("div", {
          className: "eds-structure__header"
        }, header), React.createElement(Body, {
          navItems: navItems,
          hasIndependentScrolling: hasIndependentScrolling,
          sideDrawerDescription: sideDrawerDescription,
          focusDrawerOptions: focusDrawerOptions,
          pageTitle: pageTitle,
          onToggleSideDrawer: _this3._handleToggleSideDrawer.bind(_this3),
          onSideDrawerDismiss: _this3._handleSideDrawerDismiss.bind(_this3),
          notificationOptions: notificationOptions,
          footer: footer,
          mainBottomBarOptions: mainBottomBarOptions
        }, children), React.createElement(Overlay, {
          options: overlayOptions
        }), React.createElement(FixedLoadingOverlay, {
          isLoading: isLoading
        }));
      });
    }
  }]);

  return Structure;
}(React.PureComponent);

_defineProperty(Structure, "propTypes", {
  /**
   * Main page content
   */
  children: PropTypes.node.isRequired,

  /**
   * Array of nav list items for display in the side drawer
   */
  navItems: ITEMS_PROP_TYPE,

  /**
   * Pass a header node
   */
  header: PropTypes.node,

  /**
  /**
   * Pass a side drawer description node
   */
  sideDrawerDescription: PropTypes.node,

  /**
   * Pass a footer node
   */
  footer: PropTypes.node,

  /**
    * Page title
    */
  pageTitle: PropTypes.node,

  /**
   * Show / hide side drawer
   * `undefined`: use default logic for determining whether it should show
   * `false`: forces side drawer to be closed (overriding any existing state)
   * `true`: forces side drawer to be open (overriding any existing state)
   */
  showSideDrawer: PropTypes.bool,

  /**
   * Function to be invoked when the side drawer's state changes.
   */
  onSideDrawerChange: PropTypes.func,

  /**
   * Makes the Main content area full width
   */
  fullScreenMain: PropTypes.bool,

  /**
   * Gives the Main content area a min height
   */
  noMinHeightMain: PropTypes.bool,

  /**
   * The options used to configure the focus drawer
   */
  focusDrawerOptions: FOCUS_DRAWER_OPTIONS_PROP_TYPES,

  /**
   * The options used to configure an overlay (modal or dialog)
   */
  overlayOptions: OVERLAY_OPTIONS_PROP_TYPES,

  /**
   * The options used to configure a notification
   */
  notificationOptions: NOTIFICATION_OPTIONS_PROP_TYPES,

  /**
   * The options used to configure the fixed bottom bar that sits on top
   * of the main content
   */
  mainBottomBarOptions: BOTTOM_BAR_OPTIONS_PROP_TYPE,

  /**
   * Whether or not the main body and side drawers are independently scrollable,
   * which pins the header to the top
   */
  hasIndependentScrolling: PropTypes.bool,

  /**
   * Whether or not the page is loading and should show a loading overlay
   */
  isLoading: PropTypes.bool,

  /**
   * The root theme to apply to the page structure
   */
  rootTheme: THEME_PROP_TYPE
});

_defineProperty(Structure, "defaultProps", {
  showSideDrawer: false,
  fullScreenMain: false,
  noMinHeightMain: false,
  hasIndependentScrolling: false,
  isLoading: false
});

export { Structure as default };